import Link from 'next/link'
import { decodeSafeEntities } from '@/lib/sanitise-strings'

import AppImage from '@/components/AppImage'

import type { LinkElement } from '@/components/nav/primary/types'

type LinkListProps = {
  links: LinkElement[]
  className?: string
  onClick?: any
}

export function LinkList({ links, className = '', onClick = null }: LinkListProps): JSX.Element {
  const recursiveLinkItems = links.map((item, index) => {
    const { link } = item

    const key = `link-${link.title}-${index}`
    const isHighlightedClass = item?.highlight ? 'font-bold' : 'font-normal'

    // Use the title if it exists, otherwise use the post name
    const title = link?.title && link?.title.length ? link.title : link?.name

    if (!title) {
      return null
    }

    return (
      <li key={key} className={isHighlightedClass}>
        <Link
          href={link.url}
          onClick={onClick}
          className={`block py-6 text-17 leading-normal transition-[font-weight,color] hover:text-primary xl:text-15`}>
          <span>{decodeSafeEntities(title)}</span>
        </Link>
      </li>
    )
  })

  return <ul className={`${className} list-reset`}>{recursiveLinkItems}</ul>
}

export function LinkCard({ image, link, onClick = null }): JSX.Element {
  const { url, alt } = image ?? {}

  return (
    <figure className="group">
      <Link href={link.url} prefetch={false} onClick={onClick}>
        <AppImage
          path={url}
          alt={alt}
          width={322}
          height={200}
          className="overflow-hidden rounded-sm l:w-[220px] s:w-[180px]"
          loading="lazy"
          fetchPriority="low"
          transforms={{
            width: '322',
            height: '202',
            focus: 'auto',
            crop: 'maintain_ratio',
            dpr: '2',
          }}
        />
      </Link>

      <figcaption className="mt-12">
        <span className="block text-14 text-grey-800">Featured</span>

        <Link
          href={link.url}
          prefetch={false}
          onClick={onClick}
          className="whitespace-nowrap text-17 font-bold leading-normal transition-colors hover:text-primary group-hover:text-primary xl:text-15">
          {decodeSafeEntities(link.title)} &gt;
        </Link>
      </figcaption>
    </figure>
  )
}
